export default "__VITE_ASSET__NbP08D3B__"